/**
 * Models
 * @module models
 */
define( function (require, exports) {

    'use strict';

    /**
     * @constructor
     * @ngInject
     */
    function WidgetModel(lpWidget, lpCoreUtils, lpPortal, $resource) {
        var utils = lpCoreUtils;
        var countryCode = lpWidget.getPreference('countryCode');
        var state = {
            title: lpWidget.getPreference('title'),
            icon: utils.resolvePortalPlaceholders(lpWidget.getPreference('thumbnailUrl')),
            changePasswordUrl: lpCoreUtils.resolvePortalPlaceholders(lpWidget.getPreference('changePasswordUrl')) || lpPortal.root + '/services/rest/v1/password',
            changeForgotPasswordUrl: lpCoreUtils.resolvePortalPlaceholders(lpWidget.getPreference('changeForgotPasswordUrl')) || lpPortal.root + '/services/rest/v1/forget-password',
            checkPasswordComplexityUrl: lpCoreUtils.resolvePortalPlaceholders(lpWidget.getPreference('checkPasswordComplexityUrl')) || lpPortal.root + '/services/rest/v1/public/password/validate-complexity',
            userPortfolioInfoUrl: lpCoreUtils.resolvePortalPlaceholders(lpWidget.getPreference('userPortfolioInfoUrl')) || lpPortal.root + '/services/rest/v1/portfolio'
        };

        var model = {};
        /**
         * @public
         * @return {Object} current model state
         */
        model.getState = function () {
            return state;
        };

        model.userPortfolioInfo = $resource(state.userPortfolioInfoUrl);
        model.changePasswordUpdate = $resource(state.changePasswordUrl, '@payload', {
            put : {
              method: 'PUT'
            }
        });
        model.changePasswordSave = $resource(state.changePasswordUrl);

        model.changePasswordComplexity = $resource(state.checkPasswordComplexityUrl);
        model.changeForgotPassword = $resource(state.changeForgotPasswordUrl);

        return model;
    }

    module.exports = WidgetModel;
});



//////////////////
// WEBPACK FOOTER
// ./scripts/model.js
// module id = 8
// module chunks = 0